module.exports = __webpack_public_path__ + "img/1.39c29548.png";